<template>
  <div>
    <div v-for="tag in visibleTags" style="position:absolute;" :style="{ left: tag.x * 100 + '%', top: tag.y * 100 + '%' }">
      <div style="width:10px;height:10px;background-color:#f00;"></div>
      {{ tag.name }}
    </div>
  </div>
</template>

<script>
  export default {
    name: 'overlay',
    props: ['tags', 'time'],
    computed: {
      visibleTags() {
        return this.tags.reduce((waypoints, tag) => {
          tag.scenes.forEach(scene => {
            let before, after
            // find the waypoints before and after the current timestamp
            scene.waypoints.forEach(waypoint => {
              if (waypoint.time <= this.time && (!before || waypoint.time > before.time)) {
                before = waypoint
              }
              if (waypoint.time >= this.time && (!after || waypoint.time < after.time)) {
                after = waypoint
              }
            })
            // interpolate an intermediate position for the current time
            if (before && after) {
              const currentTimeFraction = (this.time - before.time) / (after.time - before.time)
              waypoints.push({
                x: before.x + (after.x - before.x) * currentTimeFraction,
                y: before.y + (after.y - before.y) * currentTimeFraction,
                ...tag
              })
            }
          })
          return waypoints
        }, [])
      }
    }
  }

</script>
